// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.
import * as config from "./../avileap_conf/config.json";
const awsConfig = {
  "aws_project_region": config.awsconfig.cognito.REGION,
  // "aws_cognito_identity_pool_id": "us-east-2:49cbe084-20a8-4be5-b982-911b0457aa8b",
  "aws_cognito_region": config.awsconfig.cognito.REGION,
  "aws_user_pools_id": config.awsconfig.cognito.USER_POOL_ID,
  "aws_user_pools_web_client_id": config.awsconfig.cognito.APP_CLIENT_ID,
  // "aws_user_pools_web_client_id_with_secret":config.awsconfig.cognito.App_CLIENT_ID_WITH_SECRET,
  "aws_content_delivery_bucket": config.awsconfig.s3.BUCKET,
  "aws_content_delivery_bucket_region": config.awsconfig.s3.REGION,
  "aws_content_delivery_url": config.awsconfig.s3.URL,
  "authenticationFlowType": 'USER_PASSWORD_AUTH',
  "oauth": {
    "domain": config.awsconfig.cognito.domain,
    "scope": [
      "phone",
      "email",
      "openid",
      "profile",
      "aws.cognito.signin.user.admin"
    ],
    "redirectSignIn": config.awsconfig.cognito.redirectSignIn,
    "redirectSignOut": config.awsconfig.cognito.redirectSignOut,
    "responseType": "code",
    "identity_provider": config.awsconfig.cognito.identity_provider,
  }
};


export default awsConfig;
